<template>
    <main>
        <section>
            <div class="content-960">
            </div>

            <div class="content-960 mobile-row">
                <div class="wrapper-960 clearfix">
                    <div class="titles icons icon-news-middle">
                        <h2 class="uppercase"><b>Material Didático do estágio</b></h2>
                    </div>

                    <div class="mold-txt-center">
                        <form>
                            <section class="col-sm-12">
                                <button type="button" class="btn-large-40 btn-success uppercase pull-right" @click="openCreate()">
                                    Criar
                                </button>
                                <br />
                                <br />
                            </section>
                        </form>
                    </div>

                    <div class="table-responsive standard-table header-cinza">
                        <table>
                            <thead>
                                <tr>
                                    <th>Ref. CNA Store<i @click="executeOrderBy('Obrigatorio')" class="fa fa-sort"></i></th>
                                    <th>Nome<i @click="executeOrderBy('Obrigatorio')" class="fa fa-sort"></i></th>
                                    <th>Obrigatorio<i @click="executeOrderBy('Obrigatorio')" class="fa fa-sort"></i></th>
                                    <th class="text-center" width="150"><i class="fa fa-cog"></i></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="item in result.items" v-bind:key="item.tagJobsId" class="animated fadeIn">
                                    <td>{{item.estoqueItem.referenciaCNAStore}}</td>
                                    <td>{{item.estoqueItem.nome}}</td>
                                    <td><span class="badge badge-pill" v-bind:class="{ 'badge-success': item.obrigatorio, 'badge-danger': !item.obrigatorio }">{{item.obrigatorio ? 'Sim' : 'Não'}}</span></td>

                                    <td class="text-center">
                                        <button type="button" class="btn btn-sm btn-danger" @click="openRemove({ estoqueItemId: item.estoqueItemId, estagioId: item.estagioId })">
                                            <i class="fa fa-trash-o"></i>
                                        </button>
                                        <template v-if="item.obrigatorio === true">
                                            <b-button id="btnAtualizaMD" type="button" v-b-tooltip title="Atualizar"
                                             class="btn btn-sm btn-success" @click="openRefresh({nomeEstagio:item.estagio.nome,estoqueItemId: item.estoqueItemId, estagioId: item.estagioId })"> 
                                                <i class="fa fa-refresh"></i>
                                            </b-button>
                                        </template>
                                    </td>                                    
                                </tr>
                            </tbody>
                        </table>
                    </div>
                     
                    
                    <div class="card-block no-padding">
                        <pagination :total="result.total" :page-size="filter.pageSize" :callback="executePageChanged"></pagination>
                    </div>

                </div>
            </div>
        </section>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogCreate" :hide-footer="true" title="Criar">
            <form-create v-if="dialogCreate" :estagio-id="estagioId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogEdit" :hide-footer="true" title="Editar">
            <form-edit v-if="dialogEdit" :id="estoqueItemId" @on-saved="onSaved()" @on-back="hideAll()" />
        </b-modal>

        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p>Tem certeza que deseja remover este item?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

        <b-modal :no-close-on-backdrop="true" centered v-model="dialogRefresh" title="Confirmação">
            <p>Ao clicar em "CONFIRMAR", todos os contratos VIGENTES que possuírem o estágio {{ nomeEstagio }} com a situação "PRÓXIMO"
                 e que cuja situação da entrega do material didático seja "PENDENTE", sofrerão atualização do material didático contratado.</p>
            <p>Tem certeza de que quer realizar esta ação?</p>
            <p><strong>IMPORTANTE!</strong> A atualização só acontecerá no instante que clicar no botão de CONFIRMAR.</p>
            <div slot="modal-footer">
                <button class="btn btn-sm" @click="hideAll()">
                    Cancelar
                </button>
                <button class="btn btn-sm btn-success" @click="executeAtualizacaoMDLog({userId: user.sub, estagioId:estagioId, estoqueItemId:estoqueItemId, dataAtualizacao:new Date(), ativo: true})">
                    Confirmar
                </button>
            </div>
        </b-modal>

    </main>

</template>
<script>
    import base from '@/common/base.js'
    import Auth from '@/common/auth'
    import { Api } from '@/common/api'

    import formCreate from './form-create'
    import formEdit from './form-edit'

    export default {
        name: 'estoqueitemestagio',
        mixins: [base],
        props: { estagioId: Number },
        components: { formCreate, formEdit },
        data() {
            return {
                nomeEstagio:'',

                resources: {
                    filter: 'estoqueitemestagio',
                    remove: 'estoqueitemestagio',                    
                },

                dialogRemove: false,
                dialogCreate: false,
                dialogEdit: false,
                dialogRefresh: false,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {
            openEdit: function (model) {
                this.estoqueItemId = model.estoqueItemId;
                this.dialogEdit = true;
            },
            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogCreate = false;
                this.dialogEdit = false;
                this.dialogRemove = false;
                this.dialogRefresh = false;
            },
            openRemove: function (model) {
                this.dialogRemove = true;
                this.model = model;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.hideAll();
                    this.executeLoad();
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeFilter: function (filter) {
                if (filter) this.filter = filter;
                this.executeLoad();
            },
            executePageChanged: function (index) {
                this.filter = this.defaultPageChanged(this.filter, index);
                this.executeLoad();
            },
            executeOrderBy: function (field) {
                this.filter = this.defaultOrderBy(this.filter, field);
                this.executeLoad();
            },
            executeLoad: function () {
                this.showLoading();
                this.filter.estagioId = this.estagioId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });
            },
            openRefresh: function(model){
                this.nomeEstagio = model.nomeEstagio;
                this.estoqueItemId = model.estoqueItemId;
                this.dialogRefresh = true;
            }, 
            executeAtualizacaoMDLog:function(model){
                this.model = model;
                new Api('AtualizacaoMDLog').post(model).then(data => {
                    this.$emit('on-saved', data)
                    this.hideAll();
                    this.defaultSuccessResult('Materiais atualizados com sucesso');
                    
                }, err => {
                    this.defaultErrorResult(err);
                })
            }

        },
        mounted() {
            this.executeFilter();
            this.user = Auth.currentUser();
        }

    };
</script>